import { Tag } from '@chakra-ui/react';

const StandardBadge = ({ children, colorPalette, ...props }: {
  children: React.ReactNode;
  colorPalette?: string;
} & React.ComponentProps<typeof Tag.Root>) => {
  return (
    <Tag.Root
      colorPalette={colorPalette}
      border="1.45px solid white"
      p="4.5px 8px"
      fontSize="14px"
      fontWeight={400}
      boxShadow="0 4px 6px -4px rgba(0, 0, 0, 0.25)"
      {...props}
    >
      {children}
    </Tag.Root>
  );
};

export default StandardBadge;